<template>
  <div>
    <button class="flex py-2 w-full flow-root focus:outline-none bg-gray-100 hover:bg-gray-200" @click="toggleCollapse()">
      <div class="inline-block w-full text-lg font-medium text-left px-2 uppercase">
        {{ title }}
        <span v-if="collapsed"><i class="float-right fas fa-chevron-left items-center py-1 text-gray-300 hover:text-white" /></span>
        <span v-else><i class="float-right fas fa-chevron-down items-center py-1 text-gray-300 hover:text-white" /></span>
      </div>
    </button>
    <div class="flex flex-col h-auto overflow-hidden text-sm text-gray-700" :class="!collapsed ? 'h-auto' : 'h-0'">
      <slot />
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'SideBarSection',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  setup() {
    const collapsed = ref(false)

    const toggleCollapse = () => {
      collapsed.value = !collapsed.value
    }
    return {
      collapsed,
      toggleCollapse,
    }
  },
}
</script>

<style scoped>

</style>
